import { initializeApp } from 'firebase/app';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  "projectId": "honky-pie",
    "appId": "1:322358069783:web:4b63e4e4af86841ec4aa52",
    "storageBucket": "honky-pie.firebasestorage.app",
    "apiKey": "AIzaSyB87l5HpL0xys61G8pWcApienP_jrOnMVw",
    "authDomain": "honky-pie.firebaseapp.com",
    "messagingSenderId": "322358069783"
};

export const app = initializeApp(firebaseConfig);